import { jsx as _jsx } from "react/jsx-runtime";
import { Trans } from 'react-i18next';
/**
 * Translates the specified key with support for HTML and React elements.
 * Typically, {@link useTranslator} will support all use cases, but occasionally
 * you may need to inject HTML and React elements into a translation. If that is not
 * needed use {@link useTranslator} instead.
 */
const RichTranslator = ({ components, translationKey, variables }) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    /* @ts-ignore */
    return _jsx(Trans, { components: components, i18nKey: translationKey, values: variables });
};
export default RichTranslator;
//# sourceMappingURL=RichTranslator.js.map